import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { Menu, Dropdown, Radio, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import * as S from './styles';
import * as Style from 'components/Style';

export const ComponentInputDropdown = ({ errors, name, control, onChange, options, value, disabled }) => {
  const changeLibras = useSelector(state => state.app.changeLibras);

  const [visible, setVisible] = useState(false);

  const handleMenuClick = e => {
    const textContent = e.domEvent.target.textContent;
    onChange({ target: { name: name, value: textContent } });
    setVisible(false);
  };

  const onChangeRadioButton = e => {
    onChange({ target: { name, value: e.target.value } });
  };

  const handleVisibleChange = flag => {
    setVisible(flag);
  };

  const menuItens = () => {
    return (
      <Menu onClick={handleMenuClick}>
        {options?.map(item => {
          return <Menu.Item key={item?.id}>{item?.descricao}</Menu.Item>;
        })}
      </Menu>
    );
  };

  const renderDropDown = () => {
    return (
      <>
        <Dropdown
          overlay={menuItens}
          onVisibleChange={handleVisibleChange}
          visible={visible}
          trigger={['click']}
          disabled={disabled}
        >
          <a
            className="ant-dropdown-link"
            data-testid="input Dropdown"
            onClick={e => e.preventDefault()}
            style={{ display: changeLibras ? 'none' : 'block' }}
          >
            {value} <DownOutlined />
          </a>
        </Dropdown>
      </>
    );
  };

  const renderRadioButton = () => {
    return (
      <>
        <Radio.Group
          onChange={onChangeRadioButton}
          value={value}
          style={{ display: !changeLibras ? 'none' : 'inline-block' }}
        >
          <Space direction="horizontal">
            {options?.map(x => {
              return (
                <Radio key={x.id} value={x.descricao}>
                  {x.descricao}
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </>
    );
  };

  return (
    <S.InputContain id="ComponenteInputDropdown">
      <Controller
        name={name}
        control={control}
        render={() => {
          return (
            <>
              {renderRadioButton()}
              {renderDropDown()}
              {errors && errors[name] && <Style.GlobalErro>{errors[name]?.message}</Style.GlobalErro>}
            </>
          );
        }}
      />
    </S.InputContain>
  );
};

ComponentInputDropdown.propTypes = {
  label: PropTypes.string,
  errors: PropTypes.object,
  name: PropTypes.string,
  control: PropTypes.object,
  onChange: PropTypes.func,
  setState: PropTypes.func,
  options: PropTypes.array,
};

ComponentInputDropdown.defaultProps = {
  // label: '',
  // errors: {},
  // name: '',
  // control: {},
  // onChange: () => {},
  // setState: () => {},
  // options: [],
};

export default ComponentInputDropdown;
